import { DatePipe } from "@angular/common";
import { Component, Inject, OnInit } from "@angular/core";
import {
  FormGroup,
  FormBuilder,
  FormControl,
  Validators,
} from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { GeneralService } from "src/app/Service/general.service";
import Swal from "sweetalert2";
import { SubscriptionPlanComponent } from "../subscription-plan/subscription-plan.component";

@Component({
  selector: "app-update-receipt",
  templateUrl: "./update-receipt.component.html",
  styleUrls: ["./update-receipt.component.scss"],
})
export class UpdateReceiptComponent implements OnInit {
  receipt: FormGroup;
  submitted = false;
  isedit: boolean;
  loading: boolean = false;
  error: any;
  user: any;
  success: string;
  id: any;
  receipts: any;
  receiptData: any;
  ReceiptType: any;
  baseURL: string;
  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<UpdateReceiptComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private gs: GeneralService,
    private datepipe: DatePipe
  ) {}
  ngOnInit(): void {
    this.baseURL = this.gs.getBaseurl();
    this.receipt = this.fb.group({
      userID: new FormControl(this.data.UserId, Validators.required),
      receipt_type: new FormControl(null, Validators.required),
    });
    this.gs.getReceiptType().subscribe(
      (Response: any) => {
        this.ReceiptType = Response.result;
      },
      (error) => {
        //Error callback
        this.loading = false;
        Swal.fire({
          title: error.status,
          text: "Internal Server Error",
          type: "error",
        });
        //throw error;   //You can also throw the error to a global error handler
      }
    );
    this.receipt.addControl(
      "recieptDate",
      new FormControl({ value: null, disabled: true })
    );
    this.receipt.addControl(
      "startDate",
      new FormControl({ value: null, disabled: true })
    );
    this.receipt.addControl(
      "endDate",
      new FormControl({ value: null, disabled: true })
    );
    this.receipt.addControl(
      "payment_mode",
      new FormControl({ value: null, disabled: true })
    );
    this.receipt.addControl(
      "amount",
      new FormControl({ value: null, disabled: true })
    );
    this.receipt.addControl(
      "billTo",
      new FormControl({ value: null, disabled: true })
    );
    this.receipt.addControl(
      "gst_no",
      new FormControl({ value: null, disabled: true })
    );
    this.receipt.addControl(
      "plan_name",
      new FormControl({ value: null, disabled: true })
    );
    this.receipt.addControl(
      "message",
      new FormControl({ value: null, disabled: true })
    );
    this.receipt.addControl(
      "transaction_id",
      new FormControl({ value: null, disabled: true })
    );
    this.receipt.addControl(
      "billToAddress",
      new FormControl({ value: null, disabled: true })
    );
    this.receipt.addControl(
      "chequeNumber",
      new FormControl({ value: null, disabled: true })
    );
    this.receipt.addControl(
      "chequeDate",
      new FormControl({ value: null, disabled: true })
    );
    this.receipt.addControl(
      "bankName",
      new FormControl({ value: null, disabled: true })
    );
    this.receipt.addControl(
      "bankAccountNumber",
      new FormControl({ value: null, disabled: true })
    );
    this.receipt.addControl(
      "branchName",
      new FormControl({ value: null, disabled: true })
    );
    this.GETUserAllReceipts();
    this.getusersbyid(this.data.UserId);
  }
  GETUserAllReceipts() {
    this.loading = true;
    this.gs.GETUserAllReceipts(this.data.UserId).subscribe(
      (res: any) => {
        this.loading = false;
        this.receipts = res.data;
        this.receiptData = this.receipts.find(
          (x) => Number(x.id) === Number(this.data.ReceiptId)
        );
        this.receiptData.recieptDate = this.datepipe.transform(
          this.receiptData.recieptDate,
          "dd-MM-yyyy"
        );
        this.receiptData.startDate = this.datepipe.transform(
          this.receiptData.startDate,
          "dd-MM-yyyy"
        );
        this.receiptData.endDate = this.datepipe.transform(
          this.receiptData.endDate,
          "dd-MM-yyyy"
        );
        if (this.receiptData.message === "null") {
          this.receiptData.message = "N/A";
        }
        if (this.receiptData.chequeDate === "0000-00-00") {
          this.receiptData.chequeDate = "--";
        } else {
          this.receiptData.chequeDate = this.datepipe.transform(
            this.receiptData.chequeDate,
            "dd-MM-yyyy"
          );
        }
        this.receiptData.receipt_type = Number(this.receiptData.receipt_type);
        this.receipt.patchValue(this.receiptData);
      },
      (error) => {
        //Error callback
        this.loading = false;
        Swal.fire({
          title: error.status,
          text: "Internal Server Error",
          type: "error",
        });
        //throw error;   //You can also throw the error to a global error handler
      }
    );
  }
  getusersbyid(id) {
    this.gs.getusersbyid(id).subscribe(
      (res: any) => {
        this.user = res.data[0];
        this.user.mobileno = this.user.MobileNo.split(",");
        this.user.email = this.user.EmailID.split(",");
      },
      (error) => {
        //Error callback
        this.loading = false;
        Swal.fire({
          title: error.status,
          text: "Internal Server Error",
          type: "error",
        });
        //throw error;   //You can also throw the error to a global error handler
      }
    );
  }
  onConfirmClick(): void {
    this.dialogRef.close(true);
    window.location.reload();
  }
  updateReceiptType(type) {
    if (type == undefined) {
      return;
    }
    Swal.fire({
      title: "Are you sure?",
      text: "You want to Update Receipt Type.",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      confirmButtonClass: "btn btn-danger mt-2",
      cancelButtonClass: "btn btn-success ml-2 mt-2",
      buttonsStyling: false,
    }).then((result) => {
      if (result.value) {
        const data = {
          id: this.data.ReceiptId,
          receipt_type: type,
        };
        this.loading = true;
        this.gs.updateReceipt(data).subscribe(
          (res) => {
            this.loading = false;
            if (res.error) {
              Swal.fire({
                title: res.error_code,
                text: res.message,
                type: "error",
              }).then((result) => {
                this.onConfirmClick();
              });
              return;
            } else {
              Swal.fire({
                title: "Success",
                text: res.message,
                type: "success",
              }).then((result) => {
                this.onConfirmClick();
              });
            }
          },
          (error) => {
            this.loading = false;
            Swal.fire({
              title: error.status,
              text: "Internal Server Error",
              type: "error",
            }).then((result) => {
              this.onConfirmClick();
            });
          }
        );
        return false;
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        this.receipt.patchValue(this.receiptData);
        return false;
      }
    });
  }
}
